import React from 'react';
import Placeholder from '../../../images/placeholder.svg';
import Image, { ImageData } from '../../Image';
import { Sizes } from '../../../constants/Image';
import LocalizedLink from '../../LocalizedLink';
import './styles/NewsItem.scss';
import dayjs from 'dayjs';

interface Props {
  data?: {
    slug: string;
    title: string;
    content: string;
    updatedAt: string;
    created_at?: string;
    createdAt?: string;
    categories: { title: string }[];
    preview: string;
    cover: ImageData;
  };
}

export default class NewsItem extends React.Component<Props> {
  categories() {
    const { data } = this.props;
    if (!data) {
      return null;
    }

    const categoriesMap = data.categories.map((cat, index) => {
      return <span key={index}>{cat.title}</span>;
    });
    return categoriesMap;
  }

  itemImage() {
    const { data } = this.props;
    let image = (
      <img
        src={Placeholder}
        alt=""
        className="component-news-item__image__asset"
      />
    );
    if (data?.cover) {
      image = (
        <Image
          image={data.cover}
          defaultSize={Sizes.W800}
          className="component-news-item__image__asset"
        />
      );
    }
    return image;
  }

  render() {
    const { data } = this.props;
    if (!data) {
      return null;
    }

    return (
      <LocalizedLink to={`/blogi/${data.slug}`} className="component-news-item">
        <div className="component-news-item__image">{this.itemImage()}</div>
        <div className="component-news-item__info">
          <p className="component-news-item__info__date">
            {dayjs(data.updatedAt).format('DD.MM.YYYY')}
            {this.categories()}
          </p>
          <h2 className="component-news-item__info__title leading-7 text-xl overflow-hidden mb-4 font-axi-bold">
            {data.title}
          </h2>
          <p className="component-news-item__info__preview">{data.preview}</p>
        </div>
      </LocalizedLink>
    );
  }
}
